import { Box, CircularProgress, Container, List, Typography } from "@mui/material";
import React from "react";
import { TypePlantas } from "./interace/frigorifico.interface";
//import { frigorificos } from '../../api/frigorificos';
import { useAppSelector } from "../../redux/hooks";
import { useGetPlantasByUserQuery } from "../../api/frioApi";
import { handleMutationError } from "../../api/handleMutationError";
import { PlantaComponent } from "../../components/Planta";

export const HomePage: React.FC = () => {

  const {userData } = useAppSelector((state) => state.authReducer)

  const {
    data,
    isLoading,
    isError, 
    error
  } = useGetPlantasByUserQuery(userData!.id, {
   // refetchOnMountOrArgChange: true, //revalida la informacion cuando se monta el componente, pero la revalidacion la hace en background 
    //refetchOnMountOrArgChange: 10, //revalida la informacion cuando se monta el componente pero a los 10 segundos de la ultima vez que hizo un get satisfactorio, pero la revalidacion la hace en background 
  //  refetchOnFocus: true, //revalida la informacion cuando se pone el focus
  //  refetchOnReconnect: true, //revalida la informacion cuando se vuelve a conectar el servidor
  });

  return (
    <Container 
      maxWidth={false} 
      sx={{
        px: 2, // padding horizontal: 2*8px = 16px
      }}
    > 
    {/*<Container maxWidth="xl">*/}
        {/* Título de la Lista */}
          <Typography
            textAlign="center"
            sx={{
              marginTop: 2,
              marginBottom: 2,
              fontSize: {
                xs: "1.2rem",  // móviles
                sm: "1.5rem",  // tablets
                md: "1.8rem",  // notebooks
                lg: "2rem",    // monitores grandes
                xl: "2.2rem",  // pantallas muy grandes
              },
              fontWeight: "bold",
            }}
          >             
          {"Plantas Frigorificas"}
        </Typography>
        {isError && <p>Falla Conexion con el servidor: {error? handleMutationError(error) : 'Falla no reconocida'}</p>}
        {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) :
      (
        <List>
          {(data && data.data.planta?.length !== 0) ? (
              data.data.planta!.map((planta: TypePlantas) => (
                  <PlantaComponent  key={planta.id} propsPlanta={planta} />
              )
            )): 
              ("No hay plantas para mostrar")
          }
        </List>
      )}
    </Container>
  )
}